import { render, staticRenderFns } from "./ShipPage.vue?vue&type=template&id=05010982&"
import script from "./ShipPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./ShipPage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports